import { MenuNode } from "../angular-ui-common/base-types";
import { Icon } from "../angular-ui-common/icon";

export const IAM_NAVIGATION_TREE: MenuNode[] = [
    {
        id: "iam",
        shortLabel: "MENU.IAM",
        label: "Identity Access Management",
        icon: Icon.security,
        requiredAuthorities: ['IAM__USER_PROFILES__READ'],//['xxx'], // espediente per rendere invisibile questa voce di menu
        disabled: false,
        showInPublicMenu: false,
        showInPrivateMenu: true,
        navigable: false,
        children: [
            {
                id: "iam_dashboard",
                label: "Dashboard",
                icon: Icon.dashboard,
                url: '/private/iam/iam-dashboard',
                requiredAuthorities: ['IAM__USER_PROFILES__READ'],
                disabled: false,
                showInPublicMenu: false,
                showInPrivateMenu: true,
                navigable: true
            },
            {
                id: "manage_user_profiles",
                shortLabel: "Users",
                label: "MENU.IAM.USERS",
                icon: Icon.account,
                url: '/private/iam/user-profiles',
                requiredAuthorities: ['IAM__USER_PROFILES__READ'],
                disabled: false,
                showInPublicMenu: false,
                showInPrivateMenu: true,
                navigable: true,
                children: [
                    {
                        id: "new_user_profile",
                        label: "MENU.IAM.NEW_USER",
                        icon: Icon.plusCircle,
                        url: '/private/iam/user-profiles/new',
                        requiredAuthorities: ['IAM__USER_PROFILES__EDIT'],
                        disabled: false,
                        showInPublicMenu: false,
                        showInPrivateMenu: false,
                        navigable: true
                    },
                    {
                        id: "edit_user_profile",
                        label: "MENU.IAM.EDIT_USER",
                        icon: Icon.pencil,
                        url: '/private/iam/user-profiles/:id/edit',
                        requiredAuthorities: ['IAM__USER_PROFILES__READ'],
                        disabled: false,
                        showInPublicMenu: false,
                        showInPrivateMenu: false,
                        navigable: true
                    }
                ]
            }
            , {
                id: "manage_user_account_groups",
                shortLabel: "Groups",
                label: "MENU.IAM.GROUPS",
                icon: Icon.accountGroup,
                url: '/private/iam/user-account-groups',
                requiredAuthorities: ['IAM__USER_ACCOUNT_GROUPS__READ'],
                disabled: false,
                showInPublicMenu: false,
                showInPrivateMenu: true,
                navigable: true,
                children: [
                    {
                        id: "new_user_account_group",
                        label: "MENU.IAM.NEW_GROUP",
                        icon: Icon.plusCircle,
                        url: '/private/iam/user-account-groups/new',
                        requiredAuthorities: ['IAM__USER_ACCOUNT_GROUPS__EDIT'],
                        disabled: false,
                        showInPublicMenu: false,
                        showInPrivateMenu: false,
                        navigable: true
                    }, {
                        id: "edit_user_account_group",
                        label: "MENU.IAM.EDIT_GROUP",
                        icon: Icon.pencil,
                        url: '/private/iam/user-account-groups/:id/edit',
                        requiredAuthorities: ['IAM__USER_ACCOUNT_GROUPS__READ'],
                        disabled: false,
                        showInPublicMenu: false,
                        showInPrivateMenu: false,
                        navigable: true
                    }
                ]
            }, {
                id: "manage_roles",
                shortLabel: "Roles",
                label: "MENU.IAM.ROLES",
                icon: Icon.shieldCheck,
                url: '/private/iam/roles',
                requiredAuthorities: ['IAM__ROLES__READ'],
                disabled: false,
                showInPublicMenu: false,
                showInPrivateMenu: true,
                navigable: true,
                children: [
                    {
                        id: "new_role",
                        label: "MENU.IAM.NEW_ROLE",
                        icon: Icon.plusCircle,
                        url: '/private/iam/roles/new',
                        requiredAuthorities: ['IAM__ROLES__EDIT'],
                        disabled: false,
                        showInPublicMenu: false,
                        showInPrivateMenu: false,
                        navigable: true
                    }, {
                        id: "edit_role",
                        label: "MENU.IAM.EDIT_ROLE",
                        icon: Icon.pencil,
                        url: '/private/iam/roles/:id/edit',
                        requiredAuthorities: ['IAM__ROLES__READ'],
                        disabled: false,
                        showInPublicMenu: false,
                        showInPrivateMenu: false,
                        navigable: true
                    }
                ]
            }
        ]
    }
]